import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { ConstraintClient } from '@frontend/constraint/api';
import { ConstraintDataMapper } from '@frontend/constraint/common';
import { Constraint } from '@frontend/constraint/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

const ID = 'constraint-overview';

export const ConstraintOverview = () => {
    const { currentAccount } = useAccountRepository();
    const { spotId, moduleId, slotId } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const columns: (keyof Constraint)[] = ['name', 'data', 'type', 'mode', 'column', 'column_range', 'row', 'row_range'];
    if (!slotId) columns.splice(4, 0, 'slot_id');
    if (!moduleId) columns.splice(4, 0, 'module_id');
    if (!spotId) columns.splice(4, 0, 'spot_id');
    return (
        <ReactiveObjectList<Constraint>
            id={ID}
            useStaticListId
            label={CommonMessage.OBJECTS.CONSTRAINT.PLURAL}
            type={EntityType.CONSTRAINT}
            dispatch={dispatch}
            eventListener={EntityType.SLOT}
            fetch={(arg) => {
                if (spotId && slotId) {
                    return ConstraintClient.fetchApplicableConstraints(currentAccount!, spotId, { module_id: moduleId, slot_id: slotId, ...arg });
                }
                return ConstraintClient.fetchConstraints({ spot_id: spotId, module_id: moduleId, ...arg });
            }}
            create={{
                onCreate: () => navigate('../constraints/create'),
                label: CommonMessage.OBJECTS.CONSTRAINT.DEFAULT
            }}
            columns={{
                columns,
                delete: {
                    deleteAction: (accountId: string, spotId: string, constraintId: string) =>
                        ConstraintClient.deleteSpotConstraint(accountId, spotId, constraintId),
                    deleteKeys: ['account_id', 'spot_id', 'id'],
                    displayName: (o) => o.id
                },
                update: {
                    updateAction: (o) => {
                        navigate(`/accounts/${o.account_id}/spots/${o.spot_id}/constraints/${o.id}/update`, {
                            state: spotId ? undefined : { from: 'constraints' }
                        });
                    }
                },
                customCells: new Map([
                    [
                        'data',
                        (o) => (
                            <td>
                                <ConstraintDataMapper
                                    data={o.row.original.data}
                                    type={o.row.original.type}
                                />
                            </td>
                        )
                    ]
                ])
            }}
            multiSelectOptions={{
                delete: {
                    enabled: (t) => t.length > 0,
                    delete: (ids: string[]) => ConstraintClient.deleteConstraints(ids),
                    parent: CommonMessage.OBJECTS.MODULE.DEFAULT
                }
            }}
            filter={{
                default: true,
                keys: ['constraint_type', 'module_id', 'slot_id', 'row', 'column', 'product_id'],
                queryParamKeyOverwrite: new Map([['constraint_type', 'type']]),
                type: 'platform'
            }}
            showCount
        />
    );
};

export default ConstraintOverview;
